import script from "./TodayDropItems.vue?vue&type=script&setup=true&lang=js"
export * from "./TodayDropItems.vue?vue&type=script&setup=true&lang=js"

import "./TodayDropItems.vue?vue&type=style&index=0&id=17d02305&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17d02305"]])

export default __exports__